import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, ArrowRight } from 'lucide-react';
import SectionWrapper from './ui/SectionWrapper';
import { EXAMPLES, EXAMPLE_FILTERS, goToApp } from '../constants';

const Examples = () => {
  const [filter, setFilter] = useState('All');
  const items = filter === 'All' ? EXAMPLES : EXAMPLES.filter((e) => e.category === filter);

  return (
    <SectionWrapper
      id="examples"
      eyebrow="What you can create"
      title="One platform. Infinite creative possibilities."
      action={
        <button onClick={goToApp} className="text-sm font-semibold text-brand inline-flex items-center gap-1.5 hover:gap-2.5 transition-[gap]" data-testid="examples-view-all-btn">
          View all examples <ArrowRight size={16} />
        </button>
      }
    >
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2 mb-8" data-testid="examples-filters">
        {EXAMPLE_FILTERS.map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`shrink-0 px-5 py-2 rounded-full text-sm font-medium transition-colors ${filter === f ? 'bg-brand text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}
            data-testid={`examples-filter-${f.toLowerCase().replace(/\s+/g, '-')}`}
          >
            {f}
          </button>
        ))}
      </div>

      <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        <AnimatePresence mode="popLayout">
          {items.map((ex) => (
            <motion.button
              layout
              key={ex.title}
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.96 }}
              transition={{ duration: 0.3 }}
              onClick={goToApp}
              className="group text-left rounded-2xl overflow-hidden bg-white border border-slate-200 hover:shadow-[0_20px_40px_-20px_rgba(15,10,40,0.35)] hover:-translate-y-1 transition-[box-shadow,transform] duration-300"
              data-testid={`example-card-${ex.category.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={ex.image} alt={ex.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <span className="absolute left-4 bottom-4 w-10 h-10 rounded-full bg-black/50 backdrop-blur border border-white/40 flex items-center justify-center">
                  <Play size={16} className="fill-white text-white ml-0.5" />
                </span>
              </div>
              <div className="px-4 py-3.5">
                <h3 className="font-display font-bold text-ink">{ex.title}</h3>
                <p className="text-sm text-slate-500 mt-0.5">{ex.desc}</p>
              </div>
            </motion.button>
          ))}
        </AnimatePresence>
      </motion.div>
    </SectionWrapper>
  );
};

export default Examples;
